module.exports = __webpack_public_path__ + "img/ep-8-dosis.e7ceaad6.jpg";